import '@popperjs/core';
import * as bootstrap from 'bootstrap';

// `import 'bootstrap'` (efectos secundarios) no expone nada en `window`: es un módulo ES, no el
// bundle UMD, así que sin esta asignación `window.bootstrap` queda `undefined` y todo lo que depende
// de él en `terminal.js` (modal de confirmación, popovers) se apaga en silencio —`if (!window.bootstrap) return;`
// no lanza ningún error, solo deja de interceptar el clic.
window.bootstrap = bootstrap;
